export default {
    // API_URL: 'http://localhost/b-t.one/api/public'  // dev
    API_URL: 'https://api.b-t.one'  // live
}
